module.exports = __webpack_public_path__ + "static/media/pm_up_arrow_orange.9003bbf8.svg";